import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import IFeaturesList from '../../../../../model/IFeaturesList';
import AccessoryPacksSection from '../../../accessoryPacks/accessoryPacksSection/AccessoryPacksSection';
import { useCheckSelectedFeatures } from '../../../../../hooks/features/useCheckSelectedFeatures';

export interface ILayoutPDProps {
  featuresList: IFeaturesList;
}

const LayoutPD: FC<ILayoutPDProps> = ({ featuresList }) => {
  const { handleCheckboxChange } = useCheckSelectedFeatures();

  return (
    <Box display="flex" flexDirection="column">
      <AccessoryPacksSection featuresList={featuresList} onSelect={handleCheckboxChange} />
    </Box>
  );
};

export default LayoutPD;
